// TODO re-enable alert report
export default class ErrorHandlerUtils {

    public static notifyErrorString(error: string) {
        console.error("Reported error:\n", error)

        // const errorAlertMessage: string = "Reported error:\n" + Array.from(error, e => e["errorMessage"])
        const errorAlertMessage: string = "Reported error:\n" + error
        // window.alert(errorAlertMessage)
    }

    public static notifyDbError(error) {
        console.error("Reported DB error:\n", error)

        // const errorAlertMessage: string = "Reported error:\n" + Array.from(error, e => e["errorMessage"])
        const errorAlertMessage: string = "Reported error:\n" + error.map(e => e.message).join("\n")
        // window.alert(errorAlertMessage)
    }
}